import { Textarea, TextareaProps } from "@chakra-ui/react";
import { useCallback, useEffect, useRef } from "react";

export const AutoResizeTextarea = (props: TextareaProps) => {
  const ref = useRef<HTMLTextAreaElement>(null);

  const resizeToContent = useCallback(() => {
    const textarea = ref.current;
    if (!textarea) return;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  }, []);

  useEffect(resizeToContent, [props.value, resizeToContent]);

  useEffect(() => {
    const textarea = ref.current;
    if (!textarea) return;
    const observer = new ResizeObserver(resizeToContent);
    observer.observe(textarea);
    return () => observer.disconnect();
  }, [resizeToContent]);

  return <Textarea {...props} ref={ref} resize="none" overflow="hidden" onInput={resizeToContent} />;
};
